import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../LangContext";
import {
  PAGE_LANG,
  applyGoogleTranslate,
  loadGoogleTranslateScript,
  writeGoogTransCookie,
} from "../utils/googleSiteTranslate";

/**
 * Motore di traduzione a pagina intera (Google Website Translator).
 * La bandierina in LangContext guida la lingua; qui si applica a TUTTO il DOM,
 * non solo alle chiavi i18n dell'hero/header.
 */
export default function GoogleSiteTranslator() {
  const { lang, langEpoch } = useLang();
  const { pathname } = useLocation();
  const readyRef = useRef(false);
  const pendingRef = useRef(lang);

  useEffect(() => {
    let cancelled = false;
    writeGoogTransCookie(lang);
    loadGoogleTranslateScript()
      .then(() => {
        if (cancelled) return;
        readyRef.current = true;
        // Piccolo delay: il select .goog-te-combo compare dopo l'init
        const tryApply = (attempt = 0) => {
          const ok = applyGoogleTranslate(pendingRef.current || lang);
          if (!ok && attempt < 8) {
            window.setTimeout(() => tryApply(attempt + 1), 200 + attempt * 100);
          }
        };
        tryApply();
      })
      .catch(() => {
        /* rete / script bloccato: resta i18n locale */
      });
    return () => {
      cancelled = true;
    };
    // solo mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    pendingRef.current = lang;
    writeGoogTransCookie(lang);
    if (!readyRef.current) return undefined;
    const id = window.setTimeout(() => applyGoogleTranslate(lang), 80);
    return () => window.clearTimeout(id);
  }, [lang, langEpoch]);

  // Nuova rotta SPA: ri-applica la lingua sul DOM aggiornato
  useEffect(() => {
    if (!readyRef.current || lang === PAGE_LANG) return undefined;
    const id = window.setTimeout(() => applyGoogleTranslate(lang), 250);
    return () => window.clearTimeout(id);
  }, [pathname, lang]);

  return (
    <div
      id="google_translate_element"
      className="google-site-translator"
      aria-hidden
      data-testid="google-site-translator"
    />
  );
}
